import React from "react";
import SEO from "../components/seo";
import ContentPage from "../components/content-page";
var MakronautPage = function MakronautPage(_ref) {
    var data = _ref.data;
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(SEO, {
        title: data.datoCmsMakronaut.title
    }), /*#__PURE__*/ React.createElement(ContentPage, {
        title: data.datoCmsMakronaut.title,
        content: data.datoCmsMakronaut.text
    }));
};
var query = "751480378";
export default MakronautPage;
